import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiChevronRight } = FiIcons;
const ALEX_IMG = "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvanBlZw==/955e6a1ca30c9578f0460522ba744836.jpg";
const CTA_URL = "https://www.sunsetswipe.com/#vjwAditg61TZ_vjwAditg61TZ";

export default function FloatingNav() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (dismissed || !visible) return null;

  return (
    <div className="fixed bottom-8 left-8 z-50 flex flex-col items-start gap-2">
      {/* Main Widget */}
      <a
        href={CTA_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-3 bg-white text-deepNavy pl-2 pr-4 py-2 rounded-full shadow-apple border border-gray-100 hover:shadow-apple-hover hover:border-sage-light transition-all duration-300 hover:-translate-y-1 max-w-sm no-underline"
      >
        {/* Avatar */}
        <div className="relative flex-shrink-0">
          <img
            src={ALEX_IMG}
            alt="Alex"
            className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm"
          />
          <div className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-green-500 border-2 border-white rounded-full" />
        </div>

        {/* Text */}
        <div className="flex flex-col items-start leading-tight text-left">
          <span className="text-[10px] text-mutedBlue font-semibold uppercase tracking-wider mb-0.5">
            Alex is online
          </span>
          <span className="text-sm font-semibold text-deepNavy">
            Want to see other industries I specialize in?
          </span>
        </div>

        {/* Arrow Icon */}
        <div className="w-7 h-7 rounded-full bg-sage-lightest group-hover:bg-sage text-sage group-hover:text-white flex items-center justify-center transition-all duration-300 flex-shrink-0 shadow-sm">
          <SafeIcon icon={FiChevronRight} className="w-4 h-4" />
        </div>
      </a>

      {/* Dismiss */}
      <button
        onClick={() => setDismissed(true)}
        className="w-6 h-6 rounded-full bg-white shadow-apple-sm border border-gray-100 text-gray-400 hover:text-deepNavy flex items-center justify-center transition-all duration-200 ml-2"
        aria-label="Dismiss"
      >
        <SafeIcon icon={FiX} className="w-3 h-3" />
      </button>
    </div>
  );
}